import './Services.css'

const services = [
  {
    icon: <DiagnosticIcon />,
    label: 'Fixed-Price Assessment',
    title: 'AI Diagnostic',
    body: 'A structured, fixed-price engagement that maps your business processes, data assets, and technology landscape — then identifies precisely where AI agents will deliver the most measurable value. You leave with a prioritised implementation roadmap, not a vague strategy document.',
    details: ['2–3 week engagement', 'Fixed price, no surprises', 'Prioritised opportunity map', 'Executive-ready findings'],
  },
  {
    icon: <BuildIcon />,
    label: 'End-to-End Delivery',
    title: 'Agent Implementation',
    body: 'We design, build, test, and deploy production AI agents alongside your team. From LLM selection and prompt engineering through to integration with your existing systems and compliance requirements. We don\'t hand over a prototype — we deliver software that runs in your environment.',
    details: ['Production-ready code', 'Full system integration', 'Security & compliance built in', 'Knowledge transfer included'],
  },
  {
    icon: <AdvisoryIcon />,
    label: 'Monthly Retainer',
    title: 'Ongoing Advisory',
    body: 'The AI landscape changes fast. A monthly advisory retainer keeps you ahead of it — with regular working sessions, model and tooling reviews, strategic input on new use cases, and a Principal-level engineer on call when your team hits a wall.',
    details: ['Regular working sessions', 'Model & tooling reviews', 'Strategic roadmap input', 'Principal-level access'],
  },
]

export default function Services({ onBookCall }) {
  return (
    <section className="services section section--grey" id="services">
      <div className="container">
        <div className="services__header">
          <span className="section-eyebrow">What We Do</span>
          <h2 className="section-heading">
            Three ways to work with us
          </h2>
          <p className="section-subtext" style={{ marginTop: '0.75rem' }}>
            Whether you need clarity on where to start, an agent built and shipped,
            or a trusted advisor as you scale — we have an engagement to match.
          </p>
        </div>

        <div className="services__grid">
          {services.map((s, i) => (
            <article className="service-card" key={i}>
              <div className="service-card__icon">{s.icon}</div>
              <span className="service-card__label">{s.label}</span>
              <h3 className="service-card__title">{s.title}</h3>
              <p className="service-card__body">{s.body}</p>
              <ul className="service-card__details">
                {s.details.map((d, j) => (
                  <li key={j}>
                    <CheckIcon />
                    {d}
                  </li>
                ))}
              </ul>
              <button className="btn btn--ghost-blue service-card__cta" onClick={onBookCall}>
                Discuss this service <span aria-hidden="true">→</span>
              </button>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}

function DiagnosticIcon() {
  return (
    <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="11" cy="11" r="8"/>
      <line x1="21" y1="21" x2="16.65" y2="16.65"/>
      <line x1="11" y1="8" x2="11" y2="14"/>
      <line x1="8" y1="11" x2="14" y2="11"/>
    </svg>
  )
}

function BuildIcon() {
  return (
    <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="18" height="18" rx="2"/>
      <line x1="3" y1="9" x2="21" y2="9"/>
      <line x1="9" y1="21" x2="9" y2="9"/>
    </svg>
  )
}

function AdvisoryIcon() {
  return (
    <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
    </svg>
  )
}

function CheckIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 16 16" fill="none" aria-hidden="true">
      <path d="M3 8l3.5 3.5L13 4.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}
